module.exports = __webpack_public_path__ + "static/media/notification-svgrepo-com (2).480eb968.svg";